export default __webpack_public_path__ + "static/media/widget-placement-sibling-before.6b7f3f7b.svg";